import { useState, useCallback } from 'react';
import {
  getTaskHistory,
  getCompleteTaskHistory,
} from '../services/taskHistory';

export const useTaskHistory = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchHistory = useCallback(async (taskId, limit = 50) => {
    if (!taskId) {
      setError('Task ID is required');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getTaskHistory(taskId, limit);
      setHistory(response.history || []);
      return response;
    } catch (err) {
      const errorMessage = err.message || 'Failed to load task history';
      setError(errorMessage);
      console.error('Error fetching task history:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchCompleteHistory = useCallback(async (taskId) => {
    if (!taskId) {
      setError('Task ID is required');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getCompleteTaskHistory(taskId);
      setHistory(response.history || []);
      return response;
    } catch (err) {
      const errorMessage =
        err.message || 'Failed to load complete task history';
      setError(errorMessage);
      console.error('Error fetching complete task history:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshHistory = useCallback(
    (taskId, limit = 50) => {
      return fetchHistory(taskId, limit);
    },
    [fetchHistory]
  );

  const clearHistory = useCallback(() => {
    setHistory([]);
    setError(null);
  }, []);

  return {
    history,
    loading,
    error,
    fetchHistory,
    fetchCompleteHistory,
    refreshHistory,
    clearHistory,
  };
};

export default useTaskHistory;
